<template>
  <div class="box">
    <div class="Warheader">
      <div class="logo">
        <div style="margin-right: 9px; color: #fff">
          <img style="height: 25px" src="../../assets/jpg/Kenvue.png" alt="" />
          <!-- <span>Kenvue</span> -->
        </div>
        <!-- <div><img
            src="../../assets/jpg/logoFont.svg"
            alt=""
          /></div> -->
      </div>
      <div class="title">
        <img src="../../assets/jpg/形状.svg" alt="" />
        <!-- <span style="font-size: 30px;
    font-weight: 600;">War Room</span> -->
        <div class="User">
          <div class="item">
            <p>WWID:</p>
            <p>{{ this.wwid }}</p>
          </div>
          <div class="item">
            <p>用户名:</p>
            <p>{{ this.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <van-overlay :show="show" z-index="99999">
        <div class="wrapper" @click.stop>
          <div class="block">
            <h4 style="margin: 30px auto 10px; font-weight: bold">公告</h4>
            <p
              style="
                text-align: left;
                color: rgb(121, 121, 121);
                font-size: 14px;
                padding: 5px 10px;
                line-height: 26px;
                margin: -3px auto 18px;
                display: block;
                width: 85%;
              "
              v-html="messageTie"
            ></p>
            <van-button
              size="large"
              block
              style="
                border-radius: 0px 0px 8px 8px;
                height: 52px;
                line-height: 52px;
              "
              @click="show = !showKnow"
            >
              <span>
                <p
                  style="
                    color: rgb(103, 109, 143);
                    font-size: 18px;
                    margin-top: -10px;
                  "
                >
                  <b v-show="showKnow">我知道了</b>
                </p>
              </span>
            </van-button>
          </div>
        </div>
      </van-overlay>

      <div class="containerButton">
        <div
          :class="buttonFlag === 'tab1'? 'butBGC butScgActive': 'butBGC butScg'"
          @click="changeWar('tab1')"
        >
          <span style="margin-right: 25px" :class="buttonFlag === 'tab1' ? 'activeSpan' : ''">Spike & Core Brands</span>
        </div>
        <div
          :class="buttonFlag === 'tab2' ? 'butBGC butEcActive' : 'butBGC butEc'"
          @click="changeWar('tab2')"
        >
         <span :class="buttonFlag === 'tab2' ? 'activeSpan' : ''">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Other Brands</span>
        </div>

        <!--<div :class="buttonFlag === 'tab3'? 'butBGC butBuActive': 'butBGC butBu'"
          @click="changeWar('tab3')"
        >
          <span style="margin-left: 30px" :class="buttonFlag === 'tab3' ? 'activeSpan' : ''">DCL</span>
        </div>-->

        <!-- <el-button type="danger" class=" butScgActive" 
          >FGS Daily News
        </el-button>
        <el-button type="danger" class="" 
          >EC Overview
        </el-button>
        <el-button type="danger" class=""
          >BU Achievement
        </el-button> -->
      </div>

      <transition>
        <div class="view mgt-e1">
          <Psg v-if="buttonFlag === 'tab1'"></Psg>
          <Ec v-else-if="buttonFlag === 'tab2'"></Ec>
          <Bu v-else-if="buttonFlag === 'tab3'"></Bu>
        </div>
      </transition>
    </div>
    <div class="tipsText" :class="buttonFlag === 'tab1'?'':'pdt-5'">
      <!-- *第二波天猫/京东旗舰店均为追踪现货GMV -->
      起止日期：10.15 00:00-11.11 24:00
    </div>
  </div>
</template>
<script>
import Psg from "./Psg.vue";
import Bu from "./Bu.vue";
import Ec from "./Ec.vue";
import qs from "qs";

// import Psg from '@components/WarRoom/Psg.vue'
// import Bu from '@components/WarRoom/Bu.vue'
// import Ec from '@components/WarRoom/Ec.vue'
export default {
  data() {
    return {
      buttonFlag: "tab1",
      name: "",
      wwid: "",
      show: false,
      showKnow: false,
      messageTie: "",
    };
  },
  methods: {
    getMsgNotice() {
      this.$addr
        .post("Log/getNotice", qs.stringify({ menuId: "8" }))
        .then((res) => {
          if (res.data.data.isEffective == 1) {
            this.show = true;
            this.messageTie = res.data.data.notice;
          } else {
            this.show = false;
          }
          if (res.data.data.isKnown == 1) {
            this.showKnow = true;
          } else {
            this.showKnow = false;
          }
        });
    },
    changeWar(flag) {
      this.buttonFlag = flag;
      console.log("flag :>> ", flag);
      this.sendTime(flag);
      // this.getTablist();
    },
    sendTime(menu) {
      var time = new Date();
      var y = time.getFullYear();
      var m = (time.getMonth() + 1).toString().padStart(2, "0");
      var d = time.getDate().toString().padStart(2, "0");
      var h = time.getHours().toString().padStart(2, "0");
      var mm = time.getMinutes().toString().padStart(2, "0");
      var s = time.getSeconds().toString().padStart(2, "0");
      var EndTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
      const sendEnd = {
        startDate: EndTime,
        endDate: "",
        wwid: JSON.parse(sessionStorage.getItem("userInfo")).wwid,
        name: JSON.parse(sessionStorage.getItem("userInfo")).name,
        menu: "War Room",
        operationModule: menu,
      };
      this.$addr.post("Log/insert", qs.stringify(sendEnd)).then((res) => {});
    },
    getUserInfo() {
      sessionStorage.setItem("long", "");
      sessionStorage.setItem("longFlag", false);
      if (sessionStorage.userInfo != undefined) {
        const user = JSON.parse(sessionStorage.userInfo);
        this.name = user.name;
        this.wwid = user.wwid;
      } else {
        this.$router.push({ path: "/" });
      }
    },
  },
  components: {
    Psg,
    Bu,
    Ec,
  },
  created() {
    this.getUserInfo();
    this.getMsgNotice();
    this.sendTime(this.buttonFlag);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
  font-family: "Century Gothic";
  font-style: normal;
}
.tipsText {
  text-align: left;
  padding: 15px 15px 5px;
  width: 100%;
  font-size: 10px;
  color: #fff;
}
.pdt-5{
  padding-top: 5px;
}
.china {
  font-family: "微软雅黑" !important;
}
body {
  width: 100%;
  min-height: 100%;
  position: relative;
}
.box {
  padding: 12px;
  width: 100%;
  height: 100%;
  background-color: #019881;
  overflow-y: scroll;
}
.Warheader {
  width: 100%;
  color: #fff;
}
.logo {
  display: flex;
}
.title {
  margin-top: 32px;
  margin-bottom: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.User {
  min-width: 20%;
}
.User p {
  margin: 2px;
  display: inline-block;
  font-family: "Century Gothic";
  font-style: normal;
  transform: scale(0.9);
  font-size: 9px;
  line-height: 13px;
  color: #fff;
  text-align: left;
}
.User .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container {
  padding: 0;
  margin: 0;
  min-height: 755px;
  border-radius: 20px;
}
.view {
}
.containerButton {
  display: flex;
  overflow: hidden;
  align-items: center;
  height: 43px;
  position: relative;
}
.butBGC {
  position: absolute;
  height: 100%;
  width: 33%;
  text-align: center;
  border-radius: 0 15px 0 0;
  bottom: -1px;
}
.butBGC span {
  line-height: 45px;
  color: #01B198;
}
.activeSpan {
  color: #01B198 !important;
}
.butScg {
  z-index: 1;
  width: 65%;
  font-weight: bold;
  font-size: 12px;
  background: url("../../assets/jpg/left-g-new.png") no-repeat center;
  background-size: cover;
  background-position: -3px -6px;
  left: 0;
}
.butScgActive {
  z-index: 10;
  background: url("../../assets/jpg/left-w.png") no-repeat center;
  background-size: cover;
  background-position: -3px -6px;
  width: 65%;
  font-weight: bold;
  font-size: 12px;
  left: 0;
}
.butEc {
  z-index: 1;
  width: 65%;
  font-weight: bold;
  font-size: 12px;
  right: 0;
  background: url("../../assets/jpg/right-g.png") no-repeat;
  background-position: 3px -6px;
  background-size: cover;
  /* background-position: center -10px; */
}
.butEcActive {
  z-index: 10;
  background: url("../../assets/jpg/right-w.png") no-repeat; /*mid-w.png */
  background-position: 3px -6px;
  font-weight: bold;
  font-size: 12px;
  right: 0;
  width: 65%;
  background-size: cover;
}
.butBu {
  z-index: 1;
  width: 40%;
  font-weight: bold;
  font-size: 12px;
  background: url("../../assets/jpg/right-g.png") no-repeat center;
  background-size: cover;
  background-position: 3px -6px;
  /* background-position: -17px -10px; */
  right: 0;
}
.butBuActive {
  background: url("../../assets/jpg/right-w.png") no-repeat center;
  background-size: cover;
  background-position: 3px -6px;
  z-index: 9;
  font-weight: bold;
  font-size: 12px;
  right: 0;
  width: 40%;
}
.block {
  width: 350px;
  min-height: 40px;
  line-height: 40px;
  background-color: #fff;
  text-align: center;
  font-size: 20px;
  border-radius: 8px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.mgt-e1{
  margin-top: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/WarRoom/WarIndex.vue